import { Text, Modal, Button, Navigation, Cell } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import FaqEntryUrl from 'components/FaqEntryUrl';
import ScrollableArea from 'components/ScrollableArea';
import { AccessChannel } from 'constants/index';
import { FaqEntryType } from 'constants/faq-entry';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ClosetPromotionPreCheckoutHelpModal = _ref => {
  let {
    show,
    onBack
  } = _ref;
  const translate = useTranslate('closet_promotion.pre_checkout_help_modal');

  function renderInfoBlock(type) {
    return /*#__PURE__*/_jsx(Cell, {
      title: /*#__PURE__*/_jsx(Text, {
        text: translate("".concat(type, ".title")),
        type: Text.Type.Title
      }),
      body: /*#__PURE__*/_jsx(Text, {
        text: translate("".concat(type, ".body")),
        html: true
      })
    });
  }

  function renderFaqNote() {
    const values = {
      'help-center': chunks => /*#__PURE__*/_jsx(FaqEntryUrl, {
        type: FaqEntryType.ClosetPromotion,
        accessChannel: AccessChannel.ProductLink,
        render: url => /*#__PURE__*/_jsx("a", {
          href: url,
          target: "_blank",
          rel: "noreferrer",
          children: chunks
        })
      })
    };
    return /*#__PURE__*/_jsx(Cell, {
      children: /*#__PURE__*/_jsx(Text, {
        html: true,
        text: translate('read_more', values),
        type: Text.Type.Subtitle
      })
    });
  }

  return /*#__PURE__*/_jsx(Modal, {
    show: show,
    hasScrollableContent: true,
    children: /*#__PURE__*/_jsx("div", {
      className: "u-fill-width",
      children: /*#__PURE__*/_jsxs(ScrollableArea, {
        children: [/*#__PURE__*/_jsx(Navigation, {
          left: /*#__PURE__*/_jsx(Button, {
            theme: "amplified",
            deprecatedIconName: "arrow-left",
            styling: Button.Styling.Flat,
            testId: "closet-promotion-pre-checkout-help-back-button",
            onClick: onBack
          }),
          body: /*#__PURE__*/_jsx(Text, {
            text: translate('title'),
            type: Text.Type.Title
          })
        }), renderInfoBlock('item_selection'), renderInfoBlock('featured'), renderFaqNote()]
      })
    })
  });
};

export default ClosetPromotionPreCheckoutHelpModal;